import { Box, LinearProgress } from '@mui/material';

export const LoadingBar = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress sx={{ height: 2 }} />
    </Box>
  );
};
